import axios from 'axios';

// ─── Base URL ─────────────────────────────────────────────────────────────────
// In development points to your droplet, in production same domain
const BASE_URL = process.env.REACT_APP_API_URL || 'http://159.223.213.92:3000';

// ─── Axios Instance ───────────────────────────────────────────────────────────
const api = axios.create({
  baseURL: BASE_URL,
});

// ─── Auth Interceptor ─────────────────────────────────────────────────────────
// Automatically attaches token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ledger_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ─── Response Interceptor ─────────────────────────────────────────────────────
// Automatically logs out if token expires
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('ledger_token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// ─── Auth ─────────────────────────────────────────────────────────────────────
export const login = (email, password) =>
  api.post('/api/auth/login', { email, password });

export const signup = (name, email, password) =>
  api.post('/api/auth/signup', { name, email, password });

// ─── Budget ───────────────────────────────────────────────────────────────────
export const getCategories = () =>
  api.get('/api/budget/categories');

export const addCategory = (data) =>
  api.post('/api/budget/categories', data);

export const updateCategory = (id, data) =>
  api.patch(`/api/budget/categories/${id}`, data);

export const deleteCategory = (id) =>
  api.delete(`/api/budget/categories/${id}`);

export const getBudgetSummary = () =>
  api.get('/api/budget/summary');

export const getBudgetPeriod = () =>
  api.get('/api/budget/period');

// ─── Transactions ─────────────────────────────────────────────────────────────
export const getTransactions = (filters = {}) =>
  api.get('/api/transactions', { params: filters });

export const addTransaction = (data) =>
  api.post('/api/transactions', data);

export const updateTransaction = (id, data) =>
  api.patch(`/api/transactions/${id}`, data);

export const deleteTransaction = (id) =>
  api.delete(`/api/transactions/${id}`);

// ─── Income ───────────────────────────────────────────────────────────────────
export const getIncome = () =>
  api.get('/api/income');

export const addIncome = (data) =>
  api.post('/api/income', data);

export const updateIncome = (id, data) =>
  api.patch(`/api/income/${id}`, data);

export const deleteIncome = (id) =>
  api.delete(`/api/income/${id}`);

// ─── Accounts ─────────────────────────────────────────────────────────────────
export const getAccounts = () =>
  api.get('/api/accounts');

export const getBalances = () =>
  api.get('/api/accounts/balances');

export const updateAccount = (id, data) => api.patch(`/api/accounts/${id}`, data);

// ─── Household ────────────────────────────────────────────────────────────────
export const getHousehold = () =>
  api.get('/api/household');

export const updateHousehold = (data) =>
  api.patch('/api/household', data);

export const inviteMember = (email) =>
  api.post('/api/household/invite', { email });



// ─── Plaid ────────────────────────────────────────────────────────────────────
export const createLinkToken = () =>
  api.post('/api/plaid/create-link-token');

export const exchangeToken = (public_token) =>
  api.post('/api/plaid/exchange-token', { public_token });

export const syncPlaid = (force = true) =>
  api.post(`/api/plaid/sync?force=${force}`);

export default api;

export const getPlaidMappings   = ()     => api.get('/api/plaid-mappings');
export const updatePlaidMapping = (data) => api.put('/api/plaid-mappings', data);

export const getPlaidBanks = () => api.get('/api/plaid/banks');
export const disconnectBank = (itemId) => api.delete(`/api/plaid/disconnect/${itemId}`);
export const createUpdateLinkToken = (itemId) => api.post('/api/plaid/create-update-link-token', { item_id: itemId });
export const getSavingsAdvisor  = () => api.get('/api/budget/savings-advisor');
export const getMonthlyAdvisor  = () => api.get('/api/budget/monthly-advisor');
export const getPriorities      = () => api.get('/api/budget/priorities');
export const savePriorities     = (priorities) => api.patch('/api/budget/priorities', { priorities });
export const advisorChat        = (messages) => api.post('/api/budget/advisor-chat', { messages });
// ─── Google Sheets Sync ───────────────────────────────────────────────────────
export const syncGoogleSheets = (force = true) =>
  api.post(`/api/sync/google?force=${force}`);

export const getGoogleSyncStatus = () =>
  api.get('/api/sync/google/status');

// ─── Savings & Debt ───────────────────────────────────────────────────────────
export const getSavingsGoals  = ()       => api.get('/api/savings/goals');
export const createSavingsGoal = (data)  => api.post('/api/savings/goals', data);
export const updateSavingsGoal = (id, data) => api.patch(`/api/savings/goals/${id}`, data);
export const deleteSavingsGoal = (id)    => api.delete(`/api/savings/goals/${id}`);

export const getDebts         = ()       => api.get('/api/savings/debts');
export const createDebt       = (data)   => api.post('/api/savings/debts', data);
export const updateDebt       = (id, data) => api.patch(`/api/savings/debts/${id}`, data);
export const deleteDebt       = (id)     => api.delete(`/api/savings/debts/${id}`);

export const getFinancialFocus  = ()     => api.get('/api/savings/focus');
export const updateFinancialFocus = (data) => api.patch('/api/savings/focus', data);
